import React from "react"
import "semantic-ui-css/semantic.min.css"
import { useNavigate } from "react-router-dom"
import useAuthenticationContext from "../../../contexts/Authentication/Authentication.logic/useAuthenticationContext"
import SearchBar from "./SearchBar"
import TransactionsTable from "./TransactionsTable"
import FilterStatusButton from "./FilterStatusButton"
import PaginationComponent from "./PaginationComponent"
import FilterButtonsTransactions from "./FilterButtonsTransactions"
import UnlinkedInvoicesModal from "./UnlinkedInvoicesModal"

const PrimaryView = ({
  onTransactionSearchPress,
  onRecoverTransactionsPress,
  onLaunchReconciliationAlgorithmPress,
  onRecoverInvoicesPress,
  onUnlinkedInvoicesPress,
  ...logic
} = {}) => {
  const navigate = useNavigate()
  const { userLogout } = useAuthenticationContext()

  const onLogoutPress = async () => {
    try {
      await userLogout()
      navigate("/")
    } catch (error) {
      console.error('❌ Error during logout:', error)
      // Force navigation even if logout fails
      navigate("/")
    }
  }

  return (
    <div>
      <div className="transaction-header-top">
        <h1 className="transaction-title">
          <span>Banking</span>
          {' '}
          Reconciliation
        </h1>
        <button
          type="button"
          className="recuperation ui button"
          onClick={onRecoverTransactionsPress}
        >
          <i className="history icon" />
          Recover transactions
        </button>
        <button
          type="button"
          className="recuperation ui button recoverinvoices"
          onClick={onRecoverInvoicesPress}
        >
          <i className="history icon" />
          Recover invoices
        </button>
        <button
          type="button"
          className="recuperation ui button automatchbutton"
          onClick={onLaunchReconciliationAlgorithmPress}
        >
          <i className="history icon" />
          Auto-match
        </button>
        <p className="synchro-status">
          <span className="green-dot">
            <i className="sync alternate icon" />
          </span>
          <strong>Synchronised</strong>
          {' '}
          (1 hour ago)
        </p>
        <button
          type="button"
          className="recuperation ui button logoutbutton"
          onClick={onLogoutPress}
        >
          <i className="sign-out icon" />
          Déconnexion
        </button>
      </div>
      <div className="transaction-header-bottom">
        <SearchBar
          onSearch={onTransactionSearchPress}
        />
        <FilterButtonsTransactions {...logic} />
      </div>
      <div className="filtration">
        <FilterStatusButton {...logic} />
        <button
          type="button"
          className="ui button display-button"
          onClick={onUnlinkedInvoicesPress}
        >
          <i className="unlink icon" />
          Unlinked invoices
        </button>
      </div>
      <TransactionsTable {...logic} />
      <PaginationComponent {...logic} />

      <UnlinkedInvoicesModal {...logic} />
    </div>
  )
}

export default PrimaryView
